import { Flex } from '@components';
import { styled } from '@mui/material';

export const Container = styled(Flex)(() => ({
  flexDirection: 'row',
  height: '100%',
}));

export const InfoIntroContainer = styled(Flex)(({ theme }) => ({
  flex: '1 1 auto',
  width: '50%',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  backgroundColor: '#000',
  padding: theme.spacing(2, 16),
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const StyledLogo = styled('img')(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(10),
  left: theme.spacing(14),
  width: 100,
  height: 35,
}));

export const StyledIntroImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  maxHeight: '65vh',
  flex: 1,
  objectFit: 'contain',
}));

export const FormContainer = styled(Flex)(({ theme }) => ({
  flex: '1 1 auto',
  width: '50%',
  height: '100%',
  flexDirection: 'column',
  overflowY: 'auto',
  padding: theme.spacing(16, 20),
  [theme.breakpoints.down('xl')]: {
    padding: theme.spacing(12, 20),
  },
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(12, 19),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(12, 14),
    width: '100%',
  },
}));

export const MultiInputContainer = styled(Flex)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  [theme.breakpoints.up('lg')]: { flexWrap: 'nowrap' },
  [theme.breakpoints.down('lg')]: { flexWrap: 'wrap' },
}));
